import { reducerWithInitialState } from 'typescript-fsa-reducers';
import type {
    PartsProduct,
    KINTEKI,
    ENTEKI,
    MAKIWARA,
    FULL,
    SEMI,
} from '@app/react/const/type';

interface DefaultUnitReducer {
    [KINTEKI]: {
        [FULL]: PartsProduct | null;
        [SEMI]: PartsProduct | null;
    };
    [ENTEKI]: {
        [FULL]: PartsProduct | null;
        [SEMI]: PartsProduct | null;
    };
    [MAKIWARA]: {
        [FULL]: PartsProduct | null;
        [SEMI]: PartsProduct | null;
    };
}

const initState: DefaultUnitReducer = {
    kinteki: {
        full: null,
        semi: null,
    },
    enteki: {
        full: null,
        semi: null,
    },
    makiwara: {
        full: null,
        semi: null,
    },
};

export const defaultUnitReducer = reducerWithInitialState(initState);
